<template>
  <div :class="'col-md-' + col + ' ' + setClass" class="input" :id="setId">
    <label>{{ label }} <span v-if="isRequired">*</span></label>
    <div class="input-content">
      <input :name="name" v-model="contentCurrency" type="text" v-money="money"
             :placeholder="placeholder" maxlength="13"
             @keydown.enter="$emit('enter-pressed')">
      <ion-icon name="cash-outline"></ion-icon>
    </div>
    <span class="input-error" v-if="inputError" :style="smallInput ? 'width: 112px;' : ''">Preencha o campo *</span>
  </div>
</template>

<script>
import {VMoney} from 'v-money'

export default {
  name: "inputCurrency",
  props: {
    label: {
      required: true,
    },
    placeholder: {
      required: true,
    },
    isRequired: {
      default: false,
    },
    col: {
      required: true,
    },
    inputError: {
      default: false,
    },
    name: {
      default: ''
    },
    setId: {
      default: '',
    },
    setClass: {
      default: '',
    },
    smallInput: {
      default: false,
    },
    fullContent: {
      default: false,
    }
  },
  data() {
    return {
      contentCurrency: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  directives: {money: VMoney},
  watch: {
    contentCurrency(newValue, oldValue) {
      if (this.fullContent) {
        newValue = newValue.replace(/[^0-9]/g, "");
      } else {
        newValue = newValue.replace(/\./g, '').replace(/^R\$\s*/, "").replace(/,(?=\d{2}$)/g, ".");
        console.log(newValue)
        // newValue = newValue.replace(/^R\$\s*/, "");
      }

      this.$emit('contentCurrency', newValue)
    }
  }
}
</script>

<style lang="scss" scoped>

.input {
  position: relative;
  margin-bottom: 20px;

  label {
    font-size: 14px;
    font-weight: 400;
    color: #191919;
    margin-bottom: 4px;

    span {
      font-weight: 400;
      font-size: 14px;
      color: #FF445D;
    }
  }

  &-content {
    position: relative;

    input {
      width: 100%;
      background: #EEF2F7;
      border-radius: 4px !important;
      padding: 6px 12px;
      border: 1px solid #EEF2F7;
      transition: .2s;
      font-size: 16px;
      font-weight: 400;
      color: #3A424E;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;

      &::placeholder {
        font-size: 16px;
        font-weight: 400;
        color: #7E8DA7;
      }

      &:hover {
        transition: .2s;
        border: 1px solid #CACACA;
      }

      &:focus-visible {
        outline: none;
        transition: .2s;
        border: 1px solid #CACACA;

        &::placeholder {
          transition: .1s;
          color: #EEF2F7;
        }
      }
    }

    ion-icon {
      position: absolute;
      right: 11px;
      top: 6px;
      font-size: 24px;
      color: #7E8DA7;
      pointer-events: none;
    }
  }

  &-error {
    position: absolute;
    left: 15px;
    bottom: -15px;
    font-size: 11px;
    color: #D9534F;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputCurrency.vue